import { render, staticRenderFns } from "./order.vue?vue&type=template&id=12e1b452&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=12e1b452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1b452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e1b452')) {
      api.createRecord('12e1b452', component.options)
    } else {
      api.reload('12e1b452', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=12e1b452&scoped=true&", function () {
      api.rerender('12e1b452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/report/placeReport/order.vue"
export default component.exports